import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {MenuItem, SelectItem} from 'primeng/api';
import {CreateDepositService} from '../../../../services/apiServices/business/create-deposit.service';
import {TranslateService} from '@ngx-translate/core';
import {BROWSERS, DeviceDetectorService} from 'ngx-device-detector';
import {ExpressDepositComponent} from '../express-deposit/express-deposit.component';
import {Subject} from 'rxjs';
import {UploadedFileType} from '../helpers/file-status.enum';
import {PostalAddress} from '../../../../model/postal-address';
import {AddressLine} from '../../../../model/address-line';
import {AddressService} from '../../../../services/apiServices/business/address.service';
import {KindOfUpload} from '../helpers/kind-of-upload.enum';
import {CommonService} from '../../../../services/apiServices/business/common.service';
import {Lre} from "../../../../model/lre";
import {DepositDepotExpressEnum, ErlTypeEnum} from "../../../../enums/deposit.enums";
import {FileSaverService} from "ngx-filesaver";
import {Metadata} from "../../../../model/metadata";
import {StorageService} from "../../../../services/storage/storage.service";
import {Unsubscribable} from "../../../mixin/unsubscribable.component";
import {SignerQualityEnum} from "../../../../enums/dropdown.enums";

const COUNTRY_TO_EXCLUDE = 'FRANCE';
const COUNTRY_LABEL_KEY = 'country';

@Component({
  selector: 'app-express-erl',
  templateUrl: './express-erl.component.html',
  styleUrls: ['./express-erl.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpressErlComponent extends Unsubscribable(class {}) implements OnInit {

  @ViewChild('addressTargetContainer', {static: false})
  addressTargetContainer: ElementRef;
  @ViewChild('addressDragContainer', {static: false})
  addressDragContainer: ElementRef;
  @Output() public modalDisplay: EventEmitter<boolean>;
  @Output() public shouldClearFiles: Subject<any>;
  public templateSource: string;
  public externalLink: string;
  public showMailingModelEditor: boolean;
  public mainFile: File;
  public signature: File;
  public hasBounce: boolean = false;
  public principalFileValidity: boolean;
  public process: MenuItem[];
  public currentStep: string;
  public activeIndex = 0;
  public hasSignature: boolean;
  public depositDir;
  public foldCount: number;
  public userGrayColor: boolean = true;
  public customizedFilePdf;
  public displayLoading = false;
  public savingTrial = 1;
  public progressTimeout = null;
  public persistedCount: number;
  public depositPersisted = false;
  public depositPersistedSerialLot: number = null;
  public progressPersisted = 0;
  public pageCount = 0;
  public sigPages: any[];
  public pages: any[];
  public selectedPage = 0;
  public posX: number;
  public posY: number;
  public width: number;
  public height: number;
  public cWidth: number;
  public cHeight: number;
  public resultItems: string[];
  public userEditedAddress: boolean;
  public extractedAddress: PostalAddress;
  public senderAddress: PostalAddress;
  public addressToEdit: PostalAddress;
  public showEditAddress: boolean;
  public addressToEditLines: string[];
  public propertiesOfSelectedCountry: any;
  public addressItemsLabels: any;
  public selectedCountry: string;
  public formattedAddress: string[];
  public addressesLines: AddressLine[];
  public postalAddressLines: string[];
  public countryLabel: any;
  public containerBGStyle: any;
  public targetContainerStyle: any;
  public FileStatus = UploadedFileType;
  public pagesImages: any;
  public pdfToDisplay: any;
  public msBrowsers: boolean;
  public openVisualization: boolean;
  public erlInfo: Lre = null;
  public erlType: ErlTypeEnum = null;
  public recipientCount: number;
  acceptedUtinFiles = [];
  displayColumnHelp: boolean;
  public showMailingData: boolean;
  public showMailingDataMail: boolean;
  public availableMetaColumns: SelectItem[];
  public dataFileErrors: string[];
  public mailingColumns: string[];
  public dataFile: File;
  public recipientData: PostalAddress[];
  public erlDataValidRows: number;
  public erlDataInValidRows: number;
  public erlDataValidMailRows: number;
  public erlDataInValidMailRows: number;
  public erlDataValidRecipientRows: number;
  public erlDataInValidRecipientRows: number;
  public availableMeta: SelectItem[];
  public newMeta: Metadata;
  public editRecipient: PostalAddress;
  public editRecipientIndex: number;
  public metaDataList: Metadata[];
  public showEditRow: boolean;
  public modalTitleEdit: string;

  public addressRecipient: string [];
  public currentRecipientAddress: any;
  public recipientAddress: any;
  public openRecipientAddress: boolean;
  public writeManually: boolean = false;

  constructor(private createDepositService: CreateDepositService, private translate: TranslateService,
              private commonService: CommonService,
              private storageService: StorageService,
              private fileSaverService: FileSaverService,
              public addressService: AddressService,
              private deviceService: DeviceDetectorService) {
    super();
    this.modalDisplay = new EventEmitter<boolean>();
    this.shouldClearFiles = new Subject<any>();
  }

  ngOnInit() {
    this.translate.get('APPLICATION.CONTAINER_COMPONENT.MODAL_MODIFY_RECIPIENT_EXPRESS').subscribe((label: string) => {
      this.modalTitleEdit = label;
    });
    this.userEditedAddress = false;
    this.availableMeta = [{label: '', value: ''}];
    this.metaDataList = [];
    this.acceptedUtinFiles = ['pdf', 'doc', 'odt', 'docx'];
    this.msBrowsers = (BROWSERS.IE === this.deviceService.getDeviceInfo().browser || BROWSERS.MS_EDGE === this.deviceService.getDeviceInfo().browser);
    this.currentStep = ExpressDepositComponent.INFO_ERL;
    this.process = [
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.ERL.INFO')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.ERL.PARAMS')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.ERL.DATA')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.ERL.TEMPLATE')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.ERL.PREVIEW')},
    ];
    if (this.addressService.getLabelsForLang(this.translate.currentLang)) {
      this.addressItemsLabels = {
        country: JSON.parse(this.addressService.getLabelsForLang(this.translate.currentLang))
      };
    } else {
      this.addressService.labelsReady.subscribe(val => {
        if (val === this.translate.currentLang) {
          this.addressItemsLabels = {
            country: JSON.parse(this.addressService.getLabelsForLang(this.translate.currentLang))
          };
        }
      });
    }
  }

  public nextEnabled(): boolean {
    if (this.currentStep === ExpressDepositComponent.INFO_ERL) {
      return true;
    } else if (this.currentStep === ExpressDepositComponent.PARAMS_STEP) {
      return true;
    } else if (this.currentStep === ExpressDepositComponent.DATA_STEP) {
      if(this .recipientData && this.recipientData.length > 0) {
        return this.recipientData.every(recipient => this.isValidRow(recipient));
      }
      return false;
    } else if (this.currentStep === ExpressDepositComponent.TEMPLATE_STEP) {
      if(!this.writeManually) {
        return this.extractedAddress && this.extractedAddress.isValid();
      } else {
        return this.addressRecipient != null;
      }
    } else if (this.currentStep === ExpressDepositComponent.FORMATTING_STEP) {
      return true;
    } else {
      return true;
    }
  }

  public nextStep() {
    switch (this.currentStep) {
      case ExpressDepositComponent.INFO_ERL:
        this.currentStep = ExpressDepositComponent.PARAMS_STEP;
        this.activeIndex++;
        break;
      case ExpressDepositComponent.PARAMS_STEP:
        this.currentStep = this.erlType === ErlTypeEnum.ERL_UNIT
          ? ExpressDepositComponent.TEMPLATE_STEP
          : ExpressDepositComponent.DATA_STEP;
        this.showModelBrowser();
        this.activeIndex = this.erlType === ErlTypeEnum.ERL_UNIT ? this.activeIndex + 2 : this.activeIndex + 1;
        break;
      case ExpressDepositComponent.DATA_STEP:
        this.storeRecipient();
        break;
      case ExpressDepositComponent.TEMPLATE_STEP:
        if(this.erlType === ErlTypeEnum.ERL_UNIT) {
          this.storeRecipient();
        } else if(this.erlType === ErlTypeEnum.ERL_PUBLI) {
          this.validateModel();
        }
        break;
      case ExpressDepositComponent.FORMATTING_STEP :
        break;
    }
  }

  public infoERL(erl : Lre) {
    this.erlInfo = erl;
  }

  public setTypeErl(typeErl : ErlTypeEnum) {
    this.erlType = typeErl;
  }

  showModelBrowser() {
    this.userEditedAddress = false;
    this.templateSource = 'USER_PDF';
    // this.doCreateNewModel();
  }

  public setMainFile(fileType: string, files: File[]) {
    if (files && files.length === 1) {
      if (this.erlType === ErlTypeEnum.ERL_UNIT) {
        this.addExpressUnitMainFile(files[0]);
      } else if (this.erlType === ErlTypeEnum.ERL_PUBLI) {
        this.mainFile = files[0];
        this.storeRecipient()
        this.validateModel();
      }
    } else {
      this.mainFile = null;
    }
  }

  private validateModel(): void {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    if (this.mainFile !== null) {
      dataToSend.append('mainFile', this.mainFile);
    }
    this.createDepositService.addExpressMailingModel(dataToSend).subscribe(response => {
      if (response.pageCount) {
        this.pageCount = response.pageCount;
        if (response.hasOwnProperty('pagesImages')) {
          this.pagesImages = {};
          for (let i = 1; i <= response.pagesImages.length; i++) {
            this.pagesImages['page_' + i] = response.pagesImages[i - 1];
          }
        }
        this.pages = [];
        this.sigPages = [];
        for (let index = 1; index <= this.pageCount; index++) {
          this.pages.push({value: index, label: 'Page ' + index});
          this.sigPages.push({value: index, label: 'Sur la page ' + index});
        }
        if (this.hasSignature) {
          this.currentStep = ExpressDepositComponent.FORMATTING_STEP;
          this.activeIndex++;
        } else {
          this.prepareErlFinalFile({'page': 0});
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_MSG')
        });
      }
    });
  }

  private addExpressUnitMainFile(file: File) {
    const dataToSend = new FormData();
    dataToSend.append('main', file);
    dataToSend.append('depositDir', this.depositDir);
    this.createDepositService.addExpressMainFile(dataToSend).subscribe(response => {
      if (response.depositDir) {
        this.mainFile = file;
        this.depositDir = response.depositDir;
        this.pageCount = response.pageCount;
        this.sigPages = [];
        this.pages = [];
        this.pagesImages = {};
        for (let index = 1; index <= this.pageCount; index++) {
          this.pages.push({value: index, label: 'Page ' + index});
          this.sigPages.push({value: index, label: 'Sur la page ' + index});
        }

        if (response.hasOwnProperty('pagesImages')) {
          this.pagesImages = {};
          for (let i = 1; i <= response.pagesImages.length; i++) {
            this.pagesImages['page_' + i] = response.pagesImages[i - 1];
          }
          this.containerBGStyle = {
            'background-image': 'url(data:image/jpeg;base64,' + this.pagesImages['page_1'] + ')'
          };

          setTimeout(() => {
            this.initAreaConfig();
          }, 100);
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_MSG')
        });
      }
    });
  }

  public updateUploadValidity(fileType: string, validtyFromChild: boolean) {
    switch (fileType) {
      case UploadedFileType.MAIN:
        this.principalFileValidity = validtyFromChild;
        break;
    }
  }

  public setSignatureFile(file: File) {
    this.signature = file;
    this.setSignatureFlag(file !== null);
  }

  public setHasBounce(hasRebound: boolean) {
    this.hasBounce = hasRebound;
  }

  public setAddressSender(addressSender: any) {
    this.senderAddress = addressSender;
  }

  setSignatureFlag(event: boolean) {
    this.hasSignature = event;
    this.process = [
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.UNIT.PARAMS')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.UNIT.TEMPLATE')}
    ];
    if (this.hasSignature) {
      this.process.push({label: this.translate.instant('UPLOAD_COMPONENT.STEPS.ERL.FORMATTING')});
    }
    this.process.push({label: this.translate.instant('UPLOAD_COMPONENT.STEPS.ERL.PREVIEW')});
  }

  setDepositDir(value) {
    this.depositDir = value;
  }

  public updateBG(pagination: any) {
    this.selectedPage = pagination.page + 1;
    if (this.pagesImages.hasOwnProperty('page_' + this.selectedPage)) {
      this.containerBGStyle = {
        'background-image': 'url(data:image/jpeg;base64,' + this.pagesImages['page_' + this.selectedPage] + ')'
      };
    } else {
      if (this.mainFile) {
        this.createDepositService.getPageAsImage(this.depositDir, this.selectedPage).subscribe(response => {
          this.pagesImages['page_' + this.selectedPage] = response['page_' + this.selectedPage];
          this.containerBGStyle = {
            'background-image': 'url(data:image/jpeg;base64,' + this.pagesImages['page_' + this.selectedPage] + ')'
          };
        });
      }
    }
  }

  public initAreaConfig(): void {
    this.containerBGStyle = {
      'background-image': 'url(/assets/img/Document.jpg)'
    };
    this.posX = 105;
    this.posY = 48;
    this.width = 100;
    this.height = 47;
    this.updateBG({page: 0});
    setTimeout(() => {
      this.cWidth = this.addressDragContainer.nativeElement.clientWidth;
      this.cHeight = this.addressDragContainer.nativeElement.clientHeight;
      this.posX = this.posX * this.cWidth / 210;
      this.posY = this.posY * this.cHeight / 297;
      this.width = this.width * this.cWidth / 210;
      this.height = this.height * this.cHeight / 297;
      this.targetContainerStyle = {
        left: this.posX + 'px',
        top: this.posY + 'px',
        width: this.width + 'px',
        height: this.height + 'px'
      };
      this.extractRegion();
    }, 100);
  }

  public recalculateRegion(): void {
    this.posX = this.addressTargetContainer.nativeElement.getBoundingClientRect().left - this.addressDragContainer.nativeElement.getBoundingClientRect().left;
    this.posY = this.addressTargetContainer.nativeElement.getBoundingClientRect().top - this.addressDragContainer.nativeElement.getBoundingClientRect().top;
    this.width = this.addressTargetContainer.nativeElement.getBoundingClientRect().width;
    this.height = this.addressTargetContainer.nativeElement.getBoundingClientRect().height;
    this.cWidth = this.addressDragContainer.nativeElement.getBoundingClientRect().width;
    this.cHeight = this.addressDragContainer.nativeElement.getBoundingClientRect().height;
    this.extractRegion();
  }

  public extractRegion(moveNext?: boolean): void {
    const data = {
      depositDir: this.depositDir,
      page: this.selectedPage,
      posX: this.posX * 210 / this.cWidth,
      posY: this.posY * 297 / this.cHeight,
      width: this.width * 210 / this.cWidth,
      height: this.height * 297 / this.cHeight,
    };
    this.createDepositService.extractExpressAddress(data).subscribe(response => {
      if (response && response.resultItems) {
        this.resultItems = response.resultItems;
      }
      if (response && response.postalAddress) {
        this.postalAddressLines = response.postalAddress;
        if (response.objAddress) {
          this.extractedAddress = new PostalAddress(response.objAddress);
        } else {
          this.extractedAddress = new PostalAddress({});
        }
        if (response.country) {
          this.selectedCountry = response.country;
        } else {
          this.selectedCountry = 'FRANCE';
        }
        this.setCountryProperties();
        if (moveNext && this.extractedAddress.isValid()) {
          this.nextStep();
        }
      }
    });
  }

  public setCountryProperties(): void {
    if (this.addressService.getLabelsForLang(this.translate.currentLang)) {
      this.buildCountryProperties();
    } else {
      this.addressService.labelsReady.subscribe(val => {
        if (val === this.translate.currentLang) {
          this.buildCountryProperties();
        }
      });
    }
  }

  buildCountryProperties() {
    this.addressesLines = [];
    this.formattedAddress = [];
    const countryKey = this.selectedCountry + ':NO-STATE';
    this.propertiesOfSelectedCountry = this.addressService.getPropertiesFromKey(countryKey);
    if (this.propertiesOfSelectedCountry) {
      if (this.addressItemsLabels.country[this.propertiesOfSelectedCountry.sIsoID]) {
        this.countryLabel = this.addressItemsLabels.country[this.propertiesOfSelectedCountry.sIsoID];
      } else {
        this.countryLabel = {};
      }
      for (const adressLine of this.propertiesOfSelectedCountry.listFmtPostalAddr.listFmtPostalAdd) {
        const line = new AddressLine(adressLine);
        let key = line.sDataLib;
        if (key && key.indexOf('country.' + this.propertiesOfSelectedCountry.sIsoID) >= 0) {
          key = key.replace('country.' + this.propertiesOfSelectedCountry.sIsoID + '.', '');
        }
        if (this.countryLabel[key]) {
          line.sDataLibValue = this.countryLabel[key];
        }
        this.addressesLines.push(line);
      }
    }
    this.tryToBuildNonElemProperties();
    this.tryToBuildElemProperties();
    this.formatGlobalAdress();
  }

  public formatGlobalAdress(): void {
    this.formattedAddress = [];

    const tempoArray = [];

    for (const addressLine of this.addressesLines) {
      const index = addressLine.iLineNumber - 1;
      if (addressLine.sDataValue) {
        if (tempoArray[index]) {
          tempoArray[index] = tempoArray[index].concat(addressLine.sDataValue);
        } else {
          tempoArray[index] = addressLine.sDataValue;
        }
      }
    }

    for (const entry of tempoArray) {
      // Specific case: for france (we're not adding the country to the finalAddress)
      if (entry && entry !== COUNTRY_TO_EXCLUDE) {
        this.formattedAddress.push(entry);
      }

    }
  }

  private tryToBuildElemProperties(): void {
    if (this.extractedAddress.mElemByName) {
      const addresProperties = this.extractedAddress.mElemByName;

      const regexElem = '(addrElem)[0-9]+';
      const arrayFromParam = [];

      for (const property in addresProperties) {
        if (addresProperties.hasOwnProperty(property) && addresProperties[property] !== '' && new RegExp(regexElem).test(property)) {
          arrayFromParam.push({property: property, value: addresProperties[property]});
        }
      }

      for (const addressLine of this.addressesLines) {
        for (const param of arrayFromParam) {
          if (addressLine.sDataName === param.property) {
            addressLine.sDataValue = param.value;
          }
        }

      }
    }
  }

  private tryToBuildNonElemProperties(): void {
    if (this.extractedAddress) {
      const addresProperties = this.extractedAddress.mElemByName;
      for (const property in addresProperties) {
        if (addresProperties.hasOwnProperty(property)) {
          if (addresProperties.hasOwnProperty(property) && addresProperties[property] !== '') {
            for (const addressLine of this.addressesLines) {
              const valueFromFold = addresProperties[property];
              if (addressLine.sDataName.includes(property) && property !== COUNTRY_LABEL_KEY) {
                addressLine.sDataValue = valueFromFold;
              }

            }
          }
        }
      }
    }
  }

  storeRecipient(): void {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);

    if(this.erlType === ErlTypeEnum.ERL_UNIT) {
      dataToSend.append('writeManually', this.writeManually ? "Y" : "N");
      if(!this.writeManually) {
        dataToSend.append('recipient', JSON.stringify(
          {
            lines: this.extractedAddress.formatted,
            countryISOId: this.extractedAddress.sCountryID,
            elements: this.extractedAddress?.mElemByName
          }));
      } else {
        dataToSend.append('recipient', JSON.stringify(this.formatAddressToSend(this.recipientAddress.elements)));
      }
    } else {
      const list = [];
      for (const entry of this.recipientData) {
        list.push({
          fields: entry.userFields,
          lines: entry.formatted,
          countryISOId: entry.sCountryID,
          elements: entry.mElemByName,
          recipientMail: entry.recipientMail,
          recipient: entry.recipient
        });
      }
      dataToSend.append('recipient', JSON.stringify(list));
      dataToSend.append('meta', JSON.stringify(this.metaDataList));
    }
    this.createDepositService.storeRecipients(dataToSend).subscribe(response => {
      if (response.recipientCount) {
        this.recipientCount = response.recipientCount;
        if (this.hasSignature) {
          this.currentStep = ExpressDepositComponent.FORMATTING_STEP;
        } else {
          if(this.erlType === ErlTypeEnum.ERL_UNIT) {
            this.prepareErlFinalFile();
          } else {
            this.currentStep = ExpressDepositComponent.TEMPLATE_STEP;
            this.showModelBrowser();
            this.activeIndex++;
          }
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_MSG')
        });
      }
    });
  }

  signaturePositionStored(stored: boolean) {
    if (stored) {
      this.prepareErlFinalFile({page: 0});
    }
  }

  prepareErlFinalFile(pagination?: any) {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    dataToSend.append('grayColor', this.userGrayColor? 'Y' : 'N');
    if(pagination){
      dataToSend.append('foldNumber', '' + pagination.page);
    }
    this.createDepositService.prepareErlFinalFile(dataToSend).subscribe(response => {
      if (response.pdfFile) {
        this.customizedFilePdf = response.pdfFile;
        this.foldCount = response.foldCount;
        if (this.currentStep !== ExpressDepositComponent.REVIEW_STEP) {
          this.currentStep = ExpressDepositComponent.REVIEW_STEP;
          this.activeIndex++;
        }
        setTimeout(() => {
          this.pdfToDisplay = null;
          this.loadVisualization(false);
        }, 100);
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_MSG')
        });
      }
    });
  }

  public loadVisualization(openModal: boolean): void {
    if (this.msBrowsers) {
      // TODO find how to preview on MS browsers
    } else {
      if (this.customizedFilePdf) {
        const blob = KindOfUpload.b64toBlob(this.customizedFilePdf);
        this.pdfToDisplay = URL.createObjectURL(blob);
        this.openVisualization = openModal;
      }
    }
  }

  public saveExpressDeposit(): void {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    this.displayLoading = true;
    this.checkProgress();
    this.createDepositService.saveExpressDeposit(dataToSend).subscribe(response => {
      this.displayLoading = false;
      clearInterval(this.progressTimeout);
      if (response.serialLotDepot) {
        this.depositPersistedSerialLot = response.serialLotDepot;
      }
      if (response.foldCount) {
        this.persistedCount = response.foldCount;
        if (this.persistedCount > 0) {
          this.depositPersisted = true;
          this.closeLoader();
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.SAVE_DEPOSIT_ERROR_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.SAVE_DEPOSIT_ERROR_MSG')
        });
      }
    });
  }

  checkProgress() {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    this.progressTimeout = setInterval(() => {
      this.createDepositService.checkExpressDepositProgress(dataToSend)
        .subscribe(response => {
        if (response.trial) {
          this.savingTrial = response.trial;
        }
        if (response.progress) {
          this.progressPersisted = response.progress;
        }
        if (response.serialLotDepot) {
          this.depositPersistedSerialLot = response.serialLotDepot;
        }
        if (response.status && (response.status === 'FINISHED' || response.status === 'FAILED' || response.status === 'NOT_FOUND')) {
          clearInterval(this.progressTimeout);
        }
      });
    }, 1000);
  }

  closeLoader() {
    this.displayLoading = false;
    this.createDepositService.runningExpressDeposit.emit(this.depositDir);
    this.modalDisplay.emit(false);
  }

  editUnitAddress() {
    this.addressToEdit = this.extractedAddress;
    if (this.extractedAddress && this.extractedAddress.formatted) {
      this.addressToEditLines = this.extractedAddress.formatted;
    }
    else {
      this.addressToEditLines = [];
    }
    setTimeout(() => {
      this.showEditAddress = true;
    }, 100);
  }


  downloadModel() {
    const content = 'Titre;Prenom;Nom;Entreprise;Adresses Mail;Telephone;Adresse 1;Adresse 2;Adresse 3;Adresse 4;Code Postal;Ville;Pays\n';
    const blob = new Blob([content], {type: 'application/csv'});
    this.fileSaverService.save(blob, 'destinataires.csv');
  }

  showColumnHelp() {
    this.displayColumnHelp = true;
  }

  public getListOfAcceptedFiles(fileStatus: string): string[] {
    switch (fileStatus) {
      case UploadedFileType.MAIN:
        return ['pdf', 'doc'];
      case UploadedFileType.ANNEX:
        return ['pdf', 'doc'];
      case UploadedFileType.DATA:
        return ['xlsx', 'xls', 'csv'];
      default:
        return [];
    }
  }

  public setDataFile(fileType: string, files: File[]) {
    if (files && files.length === 1) {
      this.checkDataFile(files[0]);
    } else {
      this.dataFile = null;
    }
  }


  editRowRecipient(infoRecipient: PostalAddress, rowIndex: number) {
    this.editRecipient = infoRecipient;
    this.editRecipientIndex = rowIndex;
    setTimeout(() => {
      this.showEditRow = true;
    }, 100);
  }

  removeInvalidMailingRows() {
    const tempMailingData: PostalAddress[] = [];
    for (const entry of this.recipientData) {
      const isValidMail = entry.recipientMail && entry.isValidMail();
      const isValidRecipient = entry.isValidIdentityRecipient();

      if (isValidMail && isValidRecipient) {
        if (entry.isValid()) {
          tempMailingData.push(entry);
        }
      }
    }
    this.recipientData = tempMailingData;
    this.updateMailingDataCounts();
  }

  removeRecipient(recipient) {
    if (this.recipientData.indexOf(recipient) >= 0) {
      this.recipientData.splice(this.recipientData.indexOf(recipient), 1);
    }
    this.updateMailingDataCounts();
  }

  private checkDataFile(file: File) {
    this.showMailingData = false;
    this.showMailingDataMail = false;
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    dataToSend.append('depositType', DepositDepotExpressEnum.ERL);
    dataToSend.append('dataFile', file);

    this.createDepositService.checkDataFile(dataToSend).subscribe(response => {
      this.availableMetaColumns = [{value: '', label: ''}];
      if (response.dataFileErrors) {
        this.dataFileErrors = response.dataFileErrors;
      }
      if (response.columns) {
        this.mailingColumns = response.columns;
        for (const s of this.mailingColumns) {
          this.availableMetaColumns.push({value: s, label: s});
        }
      }
      if (response.dataFile) {
        this.dataFile = response.dataFile;
        this.recipientData = [];
        let id = 0;
        for (const entry of response.mailingData) {
          entry.id = id;
          id++;
          this.recipientData.push(new PostalAddress(entry));
        }
        this.updateMailingDataCounts();
        if (this.recipientData && this.recipientData.length > 0) {
          this.showMailingData = true;
        }

        if (this.recipientData.some(data => data.recipientMail)) {
          this.showMailingDataMail = true;
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_MSG')
        });
      }
    });
  }

  updateMailingDataCounts() {
    this.erlDataValidRows = 0;
    this.erlDataInValidRows = 0;
    this.erlDataValidMailRows = 0;
    this.erlDataInValidMailRows = 0;
    this.erlDataValidRecipientRows = 0;
    this.erlDataInValidRecipientRows = 0;

    if (this.recipientData && this.recipientData.length > 0) {
      for (const entry of this.recipientData) {
        if (entry.isValid()) {
          this.erlDataValidRows++;
        } else {
          this.erlDataInValidRows++;
        }

        if (entry.recipientMail && entry.isValidMail()) {
          this.erlDataValidMailRows++;
        } else {
          this.erlDataInValidMailRows++;
        }

        if (entry.isValidIdentityRecipient()) {
          this.erlDataValidRecipientRows++;
        } else {
          this.erlDataInValidRecipientRows++;
        }
      }
    }
  }

  addMeta() {
    if (this.newMeta.field === '' || this.newMeta.column === '') {
      return;
    }
    this.metaDataList.push({field: this.newMeta.field, column: this.newMeta.column});
    this.newMeta = new Metadata();
    this.buildAvailableMeta();
  }

  buildAvailableMeta() {
    this.availableMeta = [];
    this.availableMeta.push({label: '', value: ''});
    const criteriaFromStorage = this.storageService.getSearchCriteriasFromStorage();
    for (const c of criteriaFromStorage) {
      if (c.sNameId === 'persoField1' || c.sNameId === 'persoField2' || c.sNameId === 'persoField3' || c.sNameId === 'persoField4' || c.sNameId === 'persoField5' ) {
        let used = false;
        for (const m of this.metaDataList) {
          if (m.field === c.sNameId) {
            used = true;
            break;
          }
        }
        if (!used) {
          this.availableMeta.push({label: c.sLibI18n, value: c.sNameId});
        }
      }
    }
  }

  getMetaLabel(field: string) {
    const criteriaFromStorage = this.storageService.getSearchCriteriasFromStorage();
    for (const c of criteriaFromStorage) {
      if (c.sNameId === field) {
        return c.sLibI18n;
      }
    }
    return field;
  }

  removeMeta(toRemove: Metadata) {
    const temp: Metadata[] = [];
    for (const meta of this.metaDataList) {
      if (meta.field !== toRemove.field) {
        temp.push(meta);
      }
    }
    this.metaDataList = temp;
    this.buildAvailableMeta();
  }

  public freeDocMemory(documentToFree): void {
    window.URL.revokeObjectURL(documentToFree);
  }


  public isValidRow(row: PostalAddress) {
      return row.isValid() && row.isValidMail() && row.isValidIdentityRecipient();
  }

  updateRecipient(event: any) {
    this.recipientData[event.index] = event.updateRecipient;
    this.showEditRow = false;
    this.updateMailingDataCounts();
  }

  getRecipient(rowData: PostalAddress): string {
    if(rowData.recipient.signerQuality === SignerQualityEnum.PROFESSIONAL) {
      return rowData.recipient.company;
    } else if(rowData.recipient.signerQuality === SignerQualityEnum.INDIVIDUAL) {
      return rowData.recipient.lastName ? `${rowData.recipient.title} ${rowData.recipient.firstName} ${rowData.recipient.lastName}` : "";
    }
    return "";
  }

  public handleRecipientAddress(address: any): void {
    this.currentRecipientAddress = {
      sElem: address.fa,
      mElemByName: this.addressLinesToMap(address.lines)
    };
    this.recipientAddress = {
      lines:address.fa.join('\n'),
      countryISOId: address.country === "FRANCE:NO-STATE" ? "FR" : null,
      elements: this.addressLinesToMap(address.lines)
    }
    this.addressRecipient = [];
    this.addressRecipient.push(address.fa.join('\n'));
  }

  public showRecipientAddress() {
    this.openRecipientAddress = true;
  }

  public handleRecipientAddressClose(result: boolean): void {
    this.openRecipientAddress = result;
  }

  private addressLinesToMap(lines: AddressLine[]): any {
    const map: any = {};
    for (const line of lines) {
      map[line.sDataName] = line.sDataValue;
    }
    return map;
  }

  public isValidAddress(address: string[]): boolean {
    return address && address.length > 0 && address[0].split('\n').length >= 2;
  }

  private formatAddressToSend(elementAddress: any) {
    let elementsList = Object.values(elementAddress);

    if (elementsList.length > 6) {
      elementsList[5] = elementsList[5] + " " + elementsList[7];

      elementsList.splice(7, 1);
    }

    return [...elementsList];
  }

  public updateUnitAddress(address) {
    this.extractedAddress.formatted = address.fa;
    this.extractedAddress.valid = true;
    this.extractedAddress.fields.country = address.country;
    this.extractedAddress.sCountryID = address.countryID;
    this.extractedAddress.fields.country.replace(':NO-STATE', '');
    this.showEditAddress = false;
  }

  handleDestAddressClose() {
    this.showEditAddress = false;
    if (this.userEditedAddress) {
      this.doCreateNewModel(this.extractedAddress.formatted);
    }
  }

  doCreateNewModel(addressLines: string[]) {
    this.createDepositService.createNewLOOLCustomerModel(this.depositDir, addressLines).subscribe(response => {
      if (response && response.externalLink) {
        this.externalLink = response.externalLink;
        this.showMailingModelEditor = true;
      }
    });
  }

  closeEditor() {
    this.editorClosed();
  }

  editorClosed() {
    this.createDepositService.getUnitCustomerModelPDF(this.depositDir).subscribe(response => {
      if (response.depositDir) {
        this.mainFile = response.mainFile;
        this.sigPages = [];
        this.pageCount = response.pageCount;
        this.pages = [];
        for (let index = 1; index <= this.pageCount; index++) {
          this.pages.push({value: index, label: 'Page ' + index});
          this.sigPages.push({value: index, label: 'Sur la page ' + index});
        }
        this.pagesImages = {};
        if (response.hasOwnProperty('pagesImages')) {
          this.pagesImages = {};
          for (let i = 1; i <= response.pagesImages.length; i++) {
            this.pagesImages['page_' + i] = response.pagesImages[i - 1];
          }
          this.containerBGStyle = {
            'background-image': 'url(data:image/jpeg;base64,' + this.pagesImages['page_1'] + ')'
          };
          if (this.userEditedAddress) {
            this.nextStep();
          }
          else {
            setTimeout(() => {
              this.initAreaConfig();
            }, 100);
          }
        }
        this.showMailingModelEditor = false;
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_MSG')
        });
      }
    });
  }

  switchWrittingWay(event: any): void {

    this.writeManually = event.checked;

    if(event.checked) {
      this.extractedAddress = null;
    } else {
      this.addressRecipient = null;
      this.recipientAddress = null;
      this.currentRecipientAddress = null;
      this.initAreaConfig();
    }
  }

  protected readonly DepositDepotExpressEnum = DepositDepotExpressEnum;
  protected readonly ExpressDepositComponent = ExpressDepositComponent;
  protected readonly ErlTypeEnum = ErlTypeEnum;
}
